import { render } from "./Calendar.vue?vue&type=template&id=64728662&scoped=true&bindings={}"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=64728662&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64728662"

export default script